import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=f464983a&scoped=true&"
import script from "./MenuButton.vue?vue&type=script&lang=js&"
export * from "./MenuButton.vue?vue&type=script&lang=js&"
import style0 from "./MenuButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MenuButton.vue?vue&type=style&index=1&id=f464983a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f464983a",
  null
  
)

export default component.exports